"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDurationToString = void 0;
function transformDurationToString(duration) {
    const minutes = duration % 60;
    const hours = (duration - minutes) / 60;
    return ((hours === 0
        ? ""
        : hours +
            (hours === 1 ? " hour" : " hours") +
            (minutes === 0 ? "" : " and ")) +
        (minutes === 0
            ? ""
            : minutes + (minutes === 1 ? " minute" : " minutes")));
}
exports.transformDurationToString = transformDurationToString;
//# sourceMappingURL=transformDurationToString.js.map